const uberV2 = {
  voucherDueDateTitle: 'Vencimento',
};

module.exports = uberV2;
